import React, { PureComponent } from 'react';
import './Header.css';


class Header extends PureComponent {

	render() {
		const {
			tier1,
			tier2,
			clearItems,
		} = this.props;

		let subtitle = '';
		let title = tier1;
		let description = 'Please select your IBD affiliation/custodian:';
		if (tier2) {
			description = 'Please select an option based on your needs:';
			subtitle = tier1;
			title = tier2;
			if (tier2 === 'NA') {
				subtitle = '';
				title = tier1;
			}
		}

		return (
			<div>
				<div className='row'>
					<div className='col-md-12 header-subtitle'>
						{subtitle}
					</div>
				</div>
				<div className='row'>
					<div className='col-md-8  header-title'>
						{title}
					</div>
					<div className='col-md-4  header-back'>
						<div style={{ cursor: 'pointer' }} onClick={() => clearItems()}>back to all custodians</div>
					</div>
				</div>
				<div className='row'>
					<div className='col-md-12  header-description'>
						{description}
					</div>
				</div>
			</div>
		)
	}

}

export default (Header);
